import { handleActions } from 'redux-actions';

import http from '../../../shared/http';
import endpoints from '../../../../config/endpoints';

export const namespace = 'goodCategoryEditor';

// action types
const FETCH_DATA_SUCCESS = `${namespace}/fetch-data-success`;
const SET_INITIAL_VALUES = `${namespace}/set-initial-values`;
const FETCH_DATA_ERROR = `${namespace}/fetch-data-error`;
const TOGGLE_PROGRESS_BAR = `${namespace}/toggle-progress-bar`;

// initial state
const initialState = {
	data: null,
	isLoading: true,
	isError: false
};

const initialFormValues = {
	name_en: '',
	name_ru: ''
};

function mapResponseDataToStateData(data) {
	return {
		name_en: data.name_en,
		name_ru: data.name_ru
	};
}

function getCreateBannerImageRequest(data) {
	return http({
		url: endpoints.GOOD_CATEGORIES.BASE,
		method: 'post',
		actions: [SET_INITIAL_VALUES, FETCH_DATA_ERROR],
		data
	});
}

function getUpdateBannerImageRequest(id, data) {
	return http({
		url: `${endpoints.GOOD_CATEGORIES.BASE}/${id}`,
		method: 'put',
		actions: [FETCH_DATA_SUCCESS, FETCH_DATA_ERROR],
		data
	});
}

// actions
export const actions = {
	own: {
		fetchData: (props) => (dispatch) => {
			const categoryId = props.params.id;

			if (!categoryId) {
				return dispatch({ type: SET_INITIAL_VALUES });
			}

			const request = http({
				url: `${endpoints.GOOD_CATEGORIES.BASE}/${categoryId}`,
				method: 'get',
				actions: [FETCH_DATA_SUCCESS, FETCH_DATA_ERROR]
			});

			return request(dispatch);
		},
		onSubmit: (values, _, props) => (dispatch) => {
			const categoryId = props.params.id;

			dispatch(actions.own.toggleProgressBar());

			const request = categoryId
				? getUpdateBannerImageRequest(categoryId, values)
				: getCreateBannerImageRequest(values);

			return request(dispatch);
		},
		toggleProgressBar: () => ({ type: TOGGLE_PROGRESS_BAR })
	}
};

const reducers = Object.assign(
	{
		[FETCH_DATA_SUCCESS]: (state, action) => ({
			...state,
			data: mapResponseDataToStateData(action.payload.data),
			isLoading: false,
			isError: false
		}),
		[SET_INITIAL_VALUES]: (state, action) => ({
			...state,
			data: initialFormValues,
			isLoading: false,
			isError: false
		}),
		[FETCH_DATA_ERROR]: (state, action) => ({
			...state,
			isLoading: false,
			isError: true
		}),
		[TOGGLE_PROGRESS_BAR]: (state, action) => ({
			...state,
			isLoading: !state.isLoading
		})
	}
);

// reducers
export default handleActions(reducers, initialState);

// selectors
export const selectors = {
	select: (state, field) => state[namespace][field]
};


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/goods/category/editor/index.js